import styles from './comments.module.css'
// import LinkButton from 'components/LinkButton'
import CommentBox from 'components/CommentBox'
import ConversationContent from 'components/ConversationContent'
import AccountMenu from 'components/AccountMenu'
import { useConversationsByHostAndUrl } from 'data/conversations/client'
import { isEmpty, uniqBy } from 'lodash'
import { useBlogSettingsWithSlug } from 'data/blogs/client'
// import { getBlotterUrlFromHostAndPath, getBlotterUrlFromHostAndUrl } from 'utilities/url'
import { generateAutoTweetId } from 'data/comments/client'
import { getPathFromUrl } from 'utilities/url'
import { ArrowCircleRightIcon } from '@heroicons/react/solid'
import { useEffect } from 'react'
import { TweetProcessed } from 'data/twitter/types'
import { getTweetUrl } from 'utilities/twitter'
// import { Conversation } from 'data/conversations/types'
import { HeartIcon, ReplyIcon } from '@heroicons/react/outline'
import Tooltip from 'components/Tooltip'
// import FallbackUserProfileImage from './FallbackUserProfileImage.svg'

type Props = {
  hostId: string,
  url: string,
}

const _30_SECS_IN_MS = 30 * 1000

const Comments = ({ hostId, url }: Props) => {
  console.log('Load Blotter Commenting', hostId, url)
  const { blogSettings } = useBlogSettingsWithSlug(hostId)
  const { conversations: rawConversations, mutateConversations } = useConversationsByHostAndUrl(hostId, url)
  const conversations = uniqBy(rawConversations, (conversation) => conversation.externalId)
  // console.log({ conversations })
  // const [isTimerStarted, setIsTimerStarted] = useState(false)
  // useEffect(() => {
  //   setTimeout(() => {
  //     console.log('TIMEOUT 5000')
  //   }, 5000)
  // }, [])
  useEffect(() => {
    // const checkForConversationsIfNeeded = () => {
    //   if (conversations && isEmpty(conversations)) {
    //     mutateConversations()
    //   }
    // }
    const checkForConversations = () => {
      mutateConversations()
    }
    // setIsTimerStarted(true)
    // console.log('TIMER IS STARTED')
    // When useConversations... is first called above, it will check Twitter for matches.
    // The first check below is to see if Twitter returned anything.
    // The interval check is to keep the conversation updated
    const timeout1 = setTimeout(checkForConversations, _30_SECS_IN_MS) // after 30 sec
    const interval = setInterval(checkForConversations, _30_SECS_IN_MS * 10) // 5-min repeating check
    return () => {
      // cleanup on exit
      timeout1 && clearTimeout(timeout1)
      interval && clearTimeout(interval)
    }
  }, [mutateConversations])
  // const { conversations, mutateConversations } = conversationId
  //   ? useConversationById(conversationId)
  //   : useConversationsByHostAndUrl(hostId, url)
  // console.log({ conversations })
  const path = getPathFromUrl(url)

  //  || isEmpty(conversations)
  if (!blogSettings?.commentsEnabled) {
    return null
  }
  if (isEmpty(conversations) && !blogSettings?.conversationlessCommentingEnabled) {
    return null
  }
  const conversationsToShow = conversations?.filter(conversation => conversation.isEnabled)
  const allTweetsForConversation = conversationsToShow?.reduce((previous: TweetProcessed[], conversation) => {
    return [...previous, conversation.tweets.primary, ...conversation.tweets.replies] as TweetProcessed[]
  }, [])
  // console.log({ allTweetsForConversation })
  const sumLikesForConversation =
    allTweetsForConversation?.reduce((previous: number, current) => {
      // console.log({ previous, thisLikes: current.public_metrics?.like_count })
      return previous + (current?.public_metrics?.like_count || 0)
    }, 0 as number) || 0
  const sumRetweetsForConversation =
    allTweetsForConversation?.reduce((previous: number, current) => {
      // console.log({ previous, thisLikes: current.public_metrics?.like_count })
      return previous + (current?.public_metrics?.retweet_count || 0)
    }, 0 as number) || 0
  return <div className={`${styles.conversationsContainer} blotterConversationsContainer`}>
    <div className={styles.conversations}>
      <div className={styles.commentsHeading}>
        <div className={styles.titleStack}>
          <div className={styles.commentsTitle}>
            <div>Conversations</div>
            <div className={styles.fromTwitter}>
              on Twitter
            </div>
            { !!conversationsToShow?.length && <Tooltip
              tooltip='Total Likes'
              alignment='bottom'
              className='w-32'
              color='bg-slate-600'
            >
              <div className='relative mx-auto flex justify-center items-center gap-1 mr-3'>
                <HeartIcon className='w-6 h-6 text-red-400 fill-red-400 relative -top-[1px]' />
                <div className='text-base text-slate-500 font-normal'>{sumLikesForConversation || 1}</div>
                {/* text-red-400 */}
              </div>
            </Tooltip> }
            { !!sumRetweetsForConversation && <Tooltip
              tooltip='Total Retweets'
              alignment='bottom'
              color='bg-slate-600'
            >
              <div className='relative mx-auto flex justify-center items-center gap-1'>
                <div className='relative'>
                  <ReplyIcon className='w-5 h-5 text-sky-400 relative -mt-[5px] top-[5px] left-[1px]' />
                  <ReplyIcon className='w-5 h-5 text-sky-400 relative -top-[5px] -mb-[5px] -left-[1px] transform rotate-180 mr-[2px]' />
                </div>
                <div className='text-base text-slate-500 font-normal'>{sumRetweetsForConversation}</div>
                {/* text-sky-500/80 */}
              </div>
            </Tooltip> }
          </div>
          <div className={styles.poweredBy}>
            Powered By&nbsp;<a role='button' className={styles.blotterLink} target='_out' href='https://useblotter.com'>Blotter</a>
          </div>
        </div>
        <div className={styles.accountMenu}>
          {/* <div className='relative mx-auto mt-1 flex justify-center items-center gap-1'>
            <HeartIcon className='w-7 h-7 text-red-400 fill-red-400' />
            { !!sumLikesForConversation && <div className='text-base text-slate-600'>{sumLikesForConversation}</div> }
          </div> */}
          <AccountMenu embeddedUrl={url} />
        </div>
        {/* TODO: Option to comment on Twitter directly?
        <div className={styles.commentBox}>
          <LinkButton variant='medium' color='navy' href={lastConvoUrl} isExternal>Join the Conversation</LinkButton>
        </div> */}
      </div>
      { conversationsToShow && conversationsToShow.length > 0
        ? conversationsToShow?.map((conversation) => { // , index
          const { primary, replies } = conversation.tweets
          // console.log({ primary, replies })
          return <div className={styles.conversation} key={conversation.id}>
            <ConversationContent
              conversationId={conversation?.id}
              primary={primary as TweetProcessed}
              replies={replies as TweetProcessed[]}
            />
            { primary?.id && <div className={styles.commentBox}>
              <CommentBox replyTo={primary.id} tweetUrl={primary.author_name && primary.external_id && getTweetUrl(primary.author_name, primary.external_id) || undefined} updateConversations={mutateConversations} />
            </div> }
          </div>
        })
        : <div>
          <div className={styles.beTheFirst}>Be the first to start a conversation:
            <ul className={styles.firstCommentOptions}>
              <li><ArrowCircleRightIcon height={18} width={18} color='gray' /> Reply below, or</li>
              <li><ArrowCircleRightIcon height={18} width={18} color='gray' />Tweet a message including the URL of this page</li>
            </ul>
          </div>
          <div className={styles.commentBox}>
            <CommentBox replyTo={generateAutoTweetId(hostId, path)} updateConversations={mutateConversations} />
          </div>
        </div>
      }
    </div>
  </div>
}

export default Comments
